import { createSlice,createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_BASE_URL,removeDuplicates } from "../constant/constant";


export const login_user = createAsyncThunk(
    'users/login_user',
    async (payload, { rejectWithValue }) => {
        try {
            let response =  await axios.post(`${API_BASE_URL}login.php`, payload);
                response=response.data;
            if (response.success==='0' || !response.success) {
                throw new Error(response.data.msg);
            }
            localStorage.setItem('user_session',JSON.stringify(response?.data));
            return response;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const isUserExists = createAsyncThunk(
    'api/fetchData',
    async (payload, { rejectWithValue }) => {
        try {
            let response =  await axios.post(`${API_BASE_URL}IsUserExists.php`, payload);
           
            return response.data; // Return data directly
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const updatePayment = createAsyncThunk(
    'api/fetchData',
    async (payload, { rejectWithValue }) => {
        try {
            let response =  await axios.post(`${API_BASE_URL}updatePay.php`, payload);
           
            return response.data; // Return data directly
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);



export const getCharts = createAsyncThunk(
    'api/fetchData',
    async (payload, { rejectWithValue }) => {
        try {
            let response =  await axios.post(`${API_BASE_URL}getCharts.php`, payload);
           
            return response.data; // Return data directly
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const adpaypeee = createAsyncThunk(
    'api/fetchData',
    async (payload, { rejectWithValue }) => {
        try {
            let response =  await axios.post(`${API_BASE_URL}adpayInfo.php`, payload);
           
            return response.data; // Return data directly
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);





export const update_bank_details = createAsyncThunk(
    'api/fetchDatabank',
    async (payload, { rejectWithValue }) => {
        try {
            let response =  await axios.post(`${API_BASE_URL}update_bank_details.php`, payload);
           
            return response.data; // Return data directly
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


export const verifyOtp = createAsyncThunk(
    'api/fetchData',
    async (payload, { rejectWithValue }) => {
        try {
            let response =  await axios.post(`${API_BASE_URL}otp.php`, payload);;
           
            return response.data; // Return data directly
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const signup_user = createAsyncThunk(
    'users/signup_user',
    async (payload, { rejectWithValue }) => {
        try {
            let response =  await axios.post(`${API_BASE_URL}signup.php`, payload);;
                response=response.data;
            if (response.success==='0' || !response.success) {
                throw new Error(response.msg);
            }
          
            return response;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const setFcmToken = createAsyncThunk(
    'users/FcmToken',
    async (payload, { rejectWithValue }) => {
        try {
            let response =  await axios.post(`${API_BASE_URL}setToken.php`, payload);;
                response=response.data;
            if (response.success==='0' || !response.success) {
                throw new Error(response.msg);
            }
          
            return response;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);



export const get_all_depends = createAsyncThunk(
    'users/get_all_depends',
    async (payload, { rejectWithValue }) => {
        
        try {
            if(payload.request_type==='get_rates'){

                let response =  await axios.post(`${API_BASE_URL}get_rates.php`, {});
                 return {game_results : removeDuplicates(response.data?.result)};

            }else if(payload.request_type==='get_bid_history'){

                let response_bids =  await axios.post(`${API_BASE_URL}get_bid_history.php`, payload.data);
                return {user_bids_history : response_bids.data?.result};


            }else if(payload.request_type==='get_wallet_history'){

                let response_Ac_history =  await axios.post(`${API_BASE_URL}get_wallet_history.php`, payload.data);
                return {Wallet_history : [...response_Ac_history.data?.result.reverse()]};

            }else if(payload.request_type==='get_games'){

                let response_get_games =  await axios.post(`${API_BASE_URL}get_games.php`, payload.data);
                return {all_games : removeDuplicates(response_get_games.data?.result)};
            }else if(payload.request_type==='reuest_history'){

                let reuest_history_data =  await axios.post(`${API_BASE_URL}get_request_history.php`, payload.data);
                return {reuest_history : reuest_history_data.data?.result};

            }else if(payload.request_type==='fetch_pofile'){
                let reuest_history_data =  await axios.post(`${API_BASE_URL}get_profile.php`, payload.data);
                localStorage.setItem('user_session',JSON.stringify(reuest_history_data.data.data));
                return {Info : reuest_history_data.data.data};
            }
            
             
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);



export const update_user = createAsyncThunk(
    'users/update_user',
    async (payload, { rejectWithValue }) => {
        try {
            let response =  await axios.post(`${API_BASE_URL}edit_profile.php`, payload);;
                response=response.data;
            if (response.success==='0' || !response.success) {
                throw new Error(response.data.msg);
            }
            const obj = {};
            payload.forEach((value, key) => {
              obj[key] = value;
            });
            return obj;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


export const add_fund_request = createAsyncThunk(
    'users/add_fund_request',
    async (payload, { rejectWithValue }) => {
        try {
            let response =  await axios.post(`${API_BASE_URL}add_points_request.php`, payload);;
                response=response.data;
            if (response.success==='0' || !response.success) {
                throw new Error(response.msg);
            }
            return response.msg;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const with_fund_request = createAsyncThunk(
    'users/with_fund_request',
    async (payload, { rejectWithValue }) => {
        try {
            let response =  await axios.post(`${API_BASE_URL}withdraw_request.php`, payload);;
                response=response.data;
            if (response.success==='0' || !response.success) {
                throw new Error(response.msg);
            }
            return response.msg;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);






const userSlice = createSlice({
    name: 'user',
    initialState: {
    Info: {},
    loading:false,
    error:null,
    isUserLogedIn:false,
    game_results:[],
    user_bids_history:[],
    Wallet_history:[],
    all_games:[],
    successMsg:null,
    reuest_history:[],
 },
    reducers: {
        msgPromtsuccess: (state,action) => {
            if(action.payload.error){
                state.successMsg = action.payload.msg;
            }else{
                state.error = action.payload.msg;

            }
        },
        clearmsg_promt: (state,action) => {
            if(action.payload.error){
                state.successMsg = null;
            }else{
                state.error = null;
            }
        },
        logged_user_storage: (state,action) => {
                state.Info = action.payload;
                state.isUserLogedIn=true;

        },
        loaderActionSlice: (state,action) => {
            state.loading = action.payload;
        },
        update_user_bal: (state,action) => {
            state.Info = {...state.Info,wallet:action.payload};

        },
        update_bank_redu: (state,action) => {
            state.Info = {...state.Info,bank_details:action.payload};

        },
        
    },
    extraReducers: (builder) => {
        builder
            .addCase(login_user.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(login_user.fulfilled, (state, action) => {
                state.loading = false;
                state.Info = action.payload.data;
                state.isUserLogedIn=true;
                //state.error = 'Loged in Successfully.';
            })
            .addCase(login_user.rejected, (state, action) => {
                state.loading = false;
                state.successMsg = action.payload;
            })


            .addCase(signup_user.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(signup_user.fulfilled, (state, action) => {
                state.loading = false;
                state.error = (action.payload?.success==='1')?'':action.payload?.msg;
            })
            .addCase(signup_user.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })



            .addCase(update_user.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(update_user.fulfilled, (state, action) => {
                state.loading = false;
                state.Info = {
                    email:action.payload?.email,
                    googlepay:action.payload?.gpay,
                    name:action.payload?.name,
                    paytm:action.payload?.paytm,
                    phone_number:action.payload?.phone_number,
                    phonepay:action.payload?.phonpe
                };
                state.isUserLogedIn=true;
                state.error = 'Profile Updated Successfully.';
            })
            .addCase(update_user.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })


            .addCase(add_fund_request.pending, (state, action) => {
                state.loading = true;
            })


            .addCase(add_fund_request.fulfilled, (state, action) => {
                state.loading = false;
                state.error = action.payload;                
            })

            .addCase(add_fund_request.rejected, (state, action) => {
                state.loading = false;
                state.successMsg = action.payload;
            })


            .addCase(with_fund_request.pending, (state, action) => {
                state.loading = true;
            })


            .addCase(with_fund_request.fulfilled, (state, action) => {
                state.loading = false;
                state.error = action.payload;                
            })

            .addCase(with_fund_request.rejected, (state, action) => {
                state.loading = false;
                state.successMsg = action.payload;
            })


            


            .addCase(get_all_depends.pending, (state,action) => {
                state.loading = (action.meta.arg.request_type!=='fetch_pofile')?true:false;
                state.error = null;
            })
            .addCase(get_all_depends.fulfilled, (state, action) => {
                const [firstKey] = Object.keys(action.payload);
                state.loading = false;
                state[firstKey] = action.payload[firstKey];
            })
            .addCase(get_all_depends.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
           

            
    },
});

export const { msgPromtsuccess,clearmsg_promt,logged_user_storage,loaderActionSlice,update_user_bal,update_bank_redu } = userSlice.actions;
export default userSlice.reducer;
